const styles = () => ({
  root: {
    display: 'flex',
    flex: '1 1 auto',
    minHeight: 0,
    minWidth: 0,
  },

  article: {
    display: 'flex',
    flex: '1 1 100%',
    flexDirection: 'row',
    overflow: 'auto',
  },

  dialogWidth: {
    maxWidth: 848,
  },
});

export default styles;
